<template>
  <div class="container">
<!--     <nav-bar leftName="返回" rightName="保存" @leftClick="leftClick" @rightClick="rightClick"></nav-bar> -->
    <ttip-select v-show="showSelectTip" @cancel="cancel" @sure="sure"></ttip-select>
    <setting-internet v-show="showTip" @next="nextUpdate" @now="nowUpdate"></setting-internet>
    <div class="item-container">
      <div class="menu-content">
        <switch-list :valueS="cureOn" @change="changeValue"></switch-list>
       <!--  <menu-list name="提醒时间" :canuse="cureOn" :subName="timeHrizon" @handleClick="selectTime"></menu-list> -->
        <menu-list name="服药次数" :canuse="cureOn" :subName="timeCount + '次'" :subItem="subItem" @handleClick="pillSet"></menu-list>
      </div>
      <button class="btn-block btn-save" @click="rightClick">保存</button>
    </div>
  </div>
</template>
<script>
import SwitchList from '../../components/SwitchList/SwitchList.vue'
import NavBar from '../../components/NavBar/NavBar.vue'
import MenuList from '../../components/MenuList/MenuList.vue'
import TtipSelect from '../../components/TtipSelect/TtipSelect.vue'
import SettingInternet from '../../components/SettingInternet/SettingInternet.vue'
import {
  mapState,
  mapMutations
} from 'vuex'
import Common from '../../assets/js/common.js'
import axios from 'axios'
var api = process.env.BASE_URL
var isLocal = Common.getEvn()
/* let dateSegmentData = [
  {
    is: 'cube-date-picker',
    title: '开始时间',
    min: [2019, 10, 30],
    max: [2050, 12, 31],
    startColumn: 'year',
    columnCount: 3,
    format: {
      year: 'YYYY',
      month: 'MM',
      date: 'DD'
    }
  },
  {
    is: 'cube-date-picker',
    title: '结束时间',
    min: [2019, 10, 30],
    max: [2050, 12, 31],
    startColumn: 'year',
    columnCount: 3,
    format: {
      year: 'YYYY',
      month: 'MM',
      date: 'DD'
    }
  }
] */
export default {
  components: {
    SwitchList,
    NavBar,
    MenuList,
    TtipSelect,
    SettingInternet
  },
  data () {
    return {
      value: true,
      timeHrizon: '2019/10/30-2019/10/30',
      timeHrizonBase: '2019/10/30-2019/10/30',
      timeCount: '3',
      subItem: [],
      subItemBase: [],
      cureOn: true,
      cureOnBase: true,
      isFirst: true,
      showTip: false,
      showSelectTip: false,
      deviceId: localStorage.getItem('max_device_id'),
      selectTimes: 0,
      quit: false
    }
  },
  computed: {
    ...mapState(['pillsWarnInfo', 'pillsTimes'])
  },
  methods: {
    ...mapMutations(['PillsTimes', 'PillsWarnInfo']),
    pushHistory () {
      let state = {
        title: '',
        url: '/' + isLocal
      }
      window.history.pushState(state, state.title, state.url)
    },
    popstate () {
      if (this.showTip) {
        this.showTip = false
        this.$router.back()
      } else if (this.showSelectTip) {
        this.showSelectTip = false
        if (this.quit) {
          this.$router.back()
        } else {
          this.pushHistory()
        }
      } else {
        if (!this.quit) {
          if (this.isModify(true)) {
            this.showSelectTip = !this.showSelectTip
            this.pushHistory()
          }
        }
      }
    },
    verify () {
      var _this = this
      window.addEventListener('popstate', _this.popstate, false)
    },
    cancelBack () {
      var _this = this
      window.removeEventListener('popstate', _this.popstate)
    },
    addHistory () {
      if (this.cureOn !== this.cureOnBase || !this.removeSpace().equals(this.pillsWarnInfo.execution_time_list)) {
        if (this.selectTimes === 0) {
          this.selectTimes++
          this.pushHistory()
        }
      } else {
        if (this.selectTimes !== 0) {
          this.$router.back()
          this.selectTimes--
        }
      }
    },
    selectTime () {
      if (!this.cureOn) return
      this.dateSegmentPicker.show()
    },
    leftHandleClick () {
      this.$router.push({path: '/Setting'})
    },
    changeValue (value) {
      this.cureOn = value
      this.addHistory()
    },
    pillSet () {
      if (!this.cureOn) return
      if (this.selectTimes !== 0) {
        this.selectTimes--
        this.$router.push({path: '/TakePillsSetting', query: {addBack: 'true'}})
      } else {
        this.$router.push({path: '/TakePillsSetting'})
      }
    },
    rightClick () {
      if (this.isModify()) {
        this.settingWater()
      }
    },
    leftClick () {
      if (this.isModify(true)) {
        this.showSelectTip = true
      } else {
        this.$router.push({path: '/Setting'})
      }
    },
    settingWater () {
      this.toast = this.$createToast({
        time: 0,
        txt: '保存中...',
        mask: true
      }).show()
      // let toTimeF = this.timeHrizon.split('-')[1].replace(/\//g, '-') + ' 00:00:00'
      // let fromTimeF = this.timeHrizon.split('-')[0].replace(/\//g, '-') + ' 00:00:00'
      // let toTime = Common.getUtcTime(toTimeF, 1000)
      // let fromTime = Common.getUtcTime(fromTimeF, 1000)
      if (isLocal === 'local') {
        axios.post('/Calendar/api/device/set/device/reminder/', {
          'device_id': localStorage.getItem('max_device_id'),
          'reminder': 2,
          'cure_on': this.cureOn,
          'execution_time_list': this.removeSpace()
        })
        .then(this.settingWaterSucc)
        .catch(this.settingWaterErr)
      } else {
        axios.post(api + '/Calendar/api/device/set/device/reminder/', {
          'device_id': localStorage.getItem('max_device_id'),
          'reminder': 2,
          'cure_on': this.cureOn,
          'execution_time_list': this.removeSpace()
        })
        .then(this.settingWaterSucc)
        .catch(this.settingWaterErr)
      }
    },
    settingWaterSucc (res) {
      this.toast.hide()
      var _res = res.data
      if (_res.result !== 0) {
        console.log(_res.result)
      } else {
        this.showTip = true
        this.PillsWarnInfo(_res.reminder_info[1][2])
        this.init()
      }
    },
    settingWaterErr (error) {
      this.toast.hide()
      console.log(error)
      this.toast = this.$createToast({
        txt: '设置失败',
        type: 'txt'
      }).show()
    },
    cancel () {
      this.$router.back()
    },
    sure () {
      this.$router.back()
      this.quit = true
    },
    nextUpdate () {
      this.$router.back()
    },
    nowUpdate () {
      this.$router.back()
      this.quit = true
    },
    init () {
      this.selectTimes = 0
      this.quit = false
      if (this.pillsWarnInfo) {
        const pillsWarnInfo = this.pillsWarnInfo
        // this.timeHrizon = this.timeHrizonBase = this.formateFormToDate(pillsWarnInfo)
        this.cureOn = this.cureOnBase = pillsWarnInfo.cure_on || false
        this.subItem = this.subItemBase = JSON.parse(JSON.stringify(pillsWarnInfo.execution_time_list)) || []
        this.PillsTimes(JSON.parse(JSON.stringify(this.subItem)))
        this.timeCount = pillsWarnInfo.execution_time_list.length
        if (this.timeCount !== 3 && this.timeCount !== 0 && this.timeCount !== 5) {
          this.subItem.push('')
        }
        if (this.timeCount === 5) {
          this.subItem.push('最多五次')
        }
      }
      /* if (!this.dateSegmentPicker) {
        this.dateSegmentPicker = this.$createSegmentPicker({
          data: dateSegmentData,
          onSelect: (selectedDates, selectedVals, selectedTexts) => {
            let startTime = selectedTexts[0].join('/')
            let endTime = selectedTexts[1].join('/')
            let timeHrizon = startTime + '-' + endTime
            if (this.timeHrizon !== timeHrizon) {
              this.timeHrizon = timeHrizon
            } else {
              this.$createToast({
                type: 'correct',
                txt: '时间设置相同',
                time: 1000
              }).show()
            }
          },
          onNext: (i, selectedDate, selectedValue, selectedText) => {
            dateSegmentData[1].min = selectedDate
            if (i === 0) {
              this.dateSegmentPicker.$updateProps({
                data: dateSegmentData
              })
            }
          }
        })
      } */
    },
    formateFormToDate (pillsWarnInfo) {
      if (!pillsWarnInfo.from_date || !pillsWarnInfo.to_date) return ''
      let formDateStamp = Common.getGMTTime(pillsWarnInfo.from_date, 1000)
      let toDateStamp = Common.getGMTTime(pillsWarnInfo.to_date, 1000)
      let formDateStr = Common.timestampToTime(formDateStamp, 'YY-MM-DD')
      let toDateStr = Common.timestampToTime(toDateStamp, 'YY-MM-DD')
      return formDateStr.replace(/-/g, '/') + ' - ' + toDateStr.replace(/-/g, '/')
    },
    isModify (back) {
      if (!back) {
        if (this.cureOn !== this.cureOnBase && this.cureOn === false) {
          return true
        }
        if (this.subItem.length === 0 && this.cureOn === true) {
          this.$createToast({
            type: 'correct',
            txt: '请设置服药时间',
            time: 2000
          }).show()
          return false
        }
      }
      if (this.pillsWarnInfo) {
        if (this.cureOn !== this.cureOnBase || !this.removeSpace().equals(this.pillsWarnInfo.execution_time_list)) {
          return true
        } else {
          if (!back) {
            this.$createToast({
              type: 'correct',
              txt: '您没有做任何修改',
              time: 2000
            }).show()
          }
          return false
        }
      } else {
        return false
      }
    },
    removeSpace () {
      let arr = JSON.parse(JSON.stringify(this.subItem))
      if (arr.indexOf('') > -1) {
        let index = arr.indexOf('')
        arr.splice(index, 1)
      } else if (arr.length === 6) {
        arr.splice(5, 1)
      }
      return arr
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    Common.setTitle('服药提醒')
    this.verify()
    let from = localStorage.getItem('from')
    if (this.isFirst) {
      this.isFirst = false
      return false
    } else {
      if (from === 'setting') {
        this.init()
        this.showTip = false
        this.showSelectTip = false
      }
      if (from === 'pullSetting') {
        if (!this.subItem.equals(this.pillsTimes)) {
          this.subItem.splice(0, this.subItem.length)
          let len = this.pillsTimes.length
          let timeArr = JSON.parse(JSON.stringify(this.pillsTimes))
          this.timeCount = len
          if (len !== 0) {
            if (len !== 3 && len !== 5) {
              timeArr.push('')
            } else if (len === 5) {
              timeArr.push('最多五次')
            }
            timeArr.forEach((elem, index) => {
              this.subItem.push(elem)
            })
          }
          this.addHistory()
        }
      }
    }
  },
  deactivated () {
    this.cancelBack()
  }
}
</script>
<style lang="stylus" scoped>
  .item-container
    height calc(100% - 56px)
    overflow auto
    .menu-content
      padding 0 16px
      background #ffffff
</style>


// WEBPACK FOOTER //
// src/pages/TakePills/TakePills.vue